import React from "react";
import MailIcon from "../../Assets/Svg/mail.svg";
import { Link } from "react-router-dom";
import "./ButtonContact.css";

export default function ButtonContact() {
  return (
    <Link to="/contact-us" className="Contact_Text">
      <button className="Contact_Button">
        Contact Us
        <img src={MailIcon} alt="" />
      </button>
    </Link>
  );
}
